import { Col, Form, Row } from "antd";
import { DetalleInventarioInicialTable } from "./DetalleInventarioInicialTable";
import { ItemModal } from "./modal/ItemModal";
import { useState } from "react";

export const DetalleInventarioInicialDiv = () => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  return (
    <>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Form.List
            name="detallesinventarioinicial"
            rules={[
              {
                validator: async (_, value) => {
                  if (!value || value.length < 1)
                    return Promise.reject(
                      new Error(
                        "Debe agregar al menos un detalle al inventario inicial"
                      )
                    );
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                <DetalleInventarioInicialTable
                  data={fields}
                  remove={remove}
                  handleOpenModal={handleOpenModal}
                />
                {errors?.length > 0 && (
                  <Form.Item className="ui-errorlist">
                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                )}
              </>
            )}
          </Form.List>
        </Col>
      </Row>
      <ItemModal open={openModal} handleClose={handleCloseModal} />
    </>
  );
};
